var IntrotextComponent = (function () {
    function IntrotextComponent() {
    }
    IntrotextComponent.prototype.ngOnInit = function () {
    };
    return IntrotextComponent;
}());
export { IntrotextComponent };



// WEBPACK FOOTER //
// /codebuild/output/src1521087412/src/client/web-client/src/app/theme/components/introtext/introtext.component.ts.pre-build-optimizer.js